import { lazy } from 'react';
import { RouteObject } from 'react-router';
import { pagePath } from '../utils/consts/pagePath';

const EventPage = lazy(() => import('../../view/pages/EventPage'));

export const eventRoutes: RouteObject = {
  path: pagePath.event.list,
  children: [
    {
      index: true,
      element: <EventPage />,
    },
  ],
};
